import { CopyIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  Progress,
  Spacer,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import API from "../api";

const IntegerationSteps = ({ data, setData }) => {
  const toast = useToast();
  const [isOpenAccordion, setIsOpenAccordion] = useState(true);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);

  const genrateToken = async () => {
    setLoading(true);
    await API("/partner/generate-partner-id", "POST")
      .then((data) => {
        console.log("09982 data=", data);
        if (data?.uniquePartnerId) {
          setData({ ...data, uniquePartnerId: data?.uniquePartnerId });
        }
        setStep(1);
        setLoading(false);
      })
      .catch((err) => {
        toast({
          title: "Generate Token Api: Error in fetching data!",
          description: err?.error ?? "Internal Server Error!",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        console.log("error", err);
        setLoading(false);
      });
  };

  const handleStep = async () => {
    if (step === 0) {
      await genrateToken();
    } else if (step === 1) {
      setStep(2);
      setIsOpenAccordion(false);
    } else {
      setIsOpenAccordion(false);
    }
  };

  useEffect(() => {
    if (data?.uniquePartnerId) {
      setStep(1);
    }
  }, [data?.uniquePartnerId]);
  return (
    <div
      className="form-box"
      style={{
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
        marginTop: "20px",
      }}
    >
      {console.log(data)}
      <Accordion
        allowMultiple
        defaultIndex={isOpenAccordion ? [0] : []}
        index={isOpenAccordion ? [0] : []}
      >
        <AccordionItem>
          <AccordionButton onClick={() => setIsOpenAccordion(!isOpenAccordion)}>
            <Box as="span" flex="1" textAlign="left">
              <Center>
                {" "}
                <Heading as="h3" size="lg">
                  Setup Your Partners Account
                </Heading>
              </Center>
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel pb={4}>
            <br />
            <Progress hasStripe value={step * 50} colorScheme="green" />
            <br />
            {step === 0 ? (
              <Flex>
                <Box p="7">
                  <Heading as="h5" size="sm">
                    Generate Your Unique Partner Id
                  </Heading>
                </Box>
                <Spacer />
                <Box p="4">
                  <Button colorScheme="green" onClick={handleStep}>
                    Generate
                  </Button>
                </Box>
              </Flex>
            ) : (
              <>
                {" "}
                <FormControl isRequired>
                  <Flex>
                    {" "}
                    <Box p="4">
                      {" "}
                      <FormLabel>
                        {" "}
                        <Heading as="h5" size="sm">
                          Unique Order Id :{" "}
                        </Heading>
                      </FormLabel>
                    </Box>
                    <Box p="4">
                      <Input
                        placeholder="Unique Order Id"
                        disabled={true}
                        value={data?.uniquePartnerId}
                        w={"100%"}
                      />
                    </Box>
                    {data?.uniquePartnerId ? (
                      <Box p="4">
                        {" "}
                        <Button
                          onClick={() => {
                            navigator?.clipboard?.writeText(
                              data?.uniquePartnerId
                            );
                            toast({
                              title: "Copied Successfully!",
                              description: `Unique Partner Id : ${data?.uniquePartnerId} `,
                              status: "success",
                              duration: 2000,
                              isClosable: true,
                            });
                          }}
                        >
                          {" "}
                          <Icon as={CopyIcon} />
                        </Button>
                      </Box>
                    ) : (
                      <></>
                    )}
                  </Flex>
                </FormControl>
                <Flex>
                  <Box p="7">
                    <Heading as="h5" size="sm">
                      Read Steps And Follow :
                    </Heading>
                    <br />
                    <p>
                      Copy Unique Partner Id
                      <br />
                      Go to the Merchants Codfirm Dashboard
                      <br />
                      Under overview Section : Add Unique Partner Id
                      <br />
                      Voila! Now you can see your earned commision!
                    </p>
                  </Box>
                  <Spacer />
                  <Box p="4">
                    <Button colorScheme="green" onClick={handleStep}>
                      Done
                    </Button>
                  </Box>
                </Flex>
              </>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default IntegerationSteps;
